import lorem_img from "../../assets/images/classyaboutus.jpg";
import lorem_img_1 from "../../assets/images/classycafesinger.jpg";
import { IoIosWifi, IoLogoNoSmoking } from "react-icons/io";
import { FaTruck, FaMusic } from "react-icons/fa";
import liveMusic from "../../assets/images/events.png";
import foods from "../../assets/images/food_1.jpeg";
import parties from "../../assets/images/parties.png";
import todaySpecial from "../../assets/images/today_special.jpg";
import artist_1 from "../../assets/images/image_1.jpg";
import artist_2 from "../../assets/images/image_2.jpg";
import barMenuImage_1 from "../../assets/images/bar_menu_1.jpg";
import barMenuImage_2 from "../../assets/images/bar_menu_2.jpg";
import barMenuImage_3 from "../../assets/images/bar_menu_3.jpg";
import barMenuImage_4 from "../../assets/images/bar_menu_4.jpg";
import barMenuImage_5 from "../../assets/images/bar_menu_5.jpg";
import barMenuImage_6 from "../../assets/images/bar_menu_6.jpg";
import foodMenu_1 from "../../assets/images/food_menu_1.jpg";
import foodMenu_2 from "../../assets/images/food_menu_2.jpg";
import foodMenu_3 from "../../assets/images/food_menu_3.jpg";
import foodMenu_4 from "../../assets/images/food_menu_4.jpg";
import foodMenu_5 from "../../assets/images/food_menu_5.jpg";
import foodMenu_6 from "../../assets/images/food_menu_6.jpg";
import foodMenu_7 from "../../assets/images/food_menu_7.jpg";
import foodMenu_8 from "../../assets/images/food_menu_8.jpg";
import foodMenu_9 from "../../assets/images/food_menu_9.jpg";
import contitentalCover from '../../assets/images/continental-food.jpg';
import chineseCover from '../../assets/images/Chinese-Food.jpg';
import tandoori from '../../assets/images/tandoori.jpg';
import indian from '../../assets/images/indian.jpg';
import northeast from '../../assets/images/northeast.jpeg';
import barmenu from '../../assets/images/Classy-Bar.jpeg';

const Data = [
  {
    id: 1,
    icons: [
      {
        icon: <IoLogoNoSmoking />,
        id: 1,
        note: "No Smoking Zone",
        details:
          "This is a smoke-free area. We thank you for your co-operation.",
      },
      {
        icon: <IoIosWifi />,
        id: 2,
        note: "Guest Wifi",
        details: "Use our free internet while you wait for your order!",
      },
      {
        icon: <FaTruck />,
        id: 3,
        note: "We are on Zomato",
        details: "Click here to order directly on Zomato for doorstep delivery",
      },
      {
        icon: <FaMusic />,
        note: "Live Music",
        id: 4,
        details: "Enjoy live artist performances and groove to good music",
      },
    ],
  },
  {
    id: 2,
    catalog: [
      { image: liveMusic, title: "Live Music" },
      { image: foods, title: "Foods" },
      { image: todaySpecial, title: "Todays Special" },
      { image: parties, title: "Party Packages" },
    ],
  },
  {
    id: 3,
    facilities: [
      {
        id: 1,
        image: lorem_img,
        title: "DISCOVER US",
        discription:
          "Feed your soul with a fist of “CLASSY CAFÉ BAR AND RESTAURANT” one of the finest Restaurant in Delhi",
        details:
          "We combine the finest traditional Indian cooking and multi-cuisines. Hospitality runs throughout Classy café Bar & Restaurant, from the warm welcome at the door to the merry staffs, making the story of this kitchen delightful one from your first drink to your last bite. It is a place where you can grab a great coffee, have a talk, socialize , feed the children or indulge yourself in a proper evening out, cocktails, wine and delicious food. We are situated in the heart of Delhi.",
      },
      {
        id: 2,
        image: lorem_img_1,
        title: "LIVE ARTISTE AND A COZY ENVIRONMENT",
        discription: "The more we tell about us, the more you’d like to read.",
        details:
          "But right now, how about some treats..? THE CLASSY CAFÉ BAR & RESTAURANT IS HERE TO SURPRISE YOU WITH HAPPY HOURS OVER AND OVER AGAIN.",
      },
    ],
  },
  {
    live_Events: [
      { id: 1, artist: artist_1 },
      { id: 2, artist: artist_2 },
    ],
  },
  {
    id: 5,
    barItems: [
      { image: barMenuImage_1 },
      { image: barMenuImage_2 },
      { image: barMenuImage_3 },
      { image: barMenuImage_4 },
      { image: barMenuImage_5 },
      { image: barMenuImage_6 },
    ],
    foodItems: [
      { image: foodMenu_1 },
      { image: foodMenu_2 },
      { image: foodMenu_3 },
      { image: foodMenu_4 },
      { image: foodMenu_5 },
      { image: foodMenu_6 },
      { image: foodMenu_7 },
      { image: foodMenu_8 },
      { image: foodMenu_9 },
    ],
  },
  {
    menu: [
      {
        type: "continental",
        title: "Continental",
        cover_image: contitentalCover,
        items: {
          soup: [
            {
              name: "Cream Of Peas",
              description: "veloute based creamy peas soup",
            },
            {
              name: "Cream Of Spinach",
              description: "veloute based creamy spinach soup",
            },
            {
              name: "Cream Of Broccoli",
              description: "veloute based creamy puree soup",
            },
            {
              name: "Cream Of Chicken",
              description: "thyme flavour creamy chicken soup",
            },
            {
              name: "Mushroom Soup Truffle Oil",
              description:
                "puree of sauté mushroom, garlic with broth, condiments topped with mushroom truffle oil",
            },
            {
              name: "Baby Fennel with Smoke Chicken Soup",
              description:
                "Truly Fabulous aromatic baby fennel with smoke Chicken",
            },
            {
              name: "Gacpacho Soup (Spanish Cold Soup)",
              description:
                "Colourful bell peppers, Cucumber, White Vineger, Balsamic Vineger, black pepper",
            },
            {
              name: "Mushroom Soup with Truffle Oil",
              description:
                "Delicious earthly creamy Mushroom with Truffle Oil.",
            },
            {
              name: "Tomato Corn Broth Crouton (Italian-Sweet & Soup)",
              description:
                "With the goddness of Tomatoes, Basil, Bread-crumbs, Corn in Italian Seasoning.",
            },
          ],
          salad: [
            {
              name: "Russian Salad (Veg/ Non Veg)",
              description:
                "Carrot, french beans, green peas, potato, fruit cocktail, cherry & creamy mayo",
            },
            {
              name: "Caeser Salad (Veg/ Non Veg)",
              description:
                "All time favorite crispy romaine lettuce, mayo, parmesan, parsley, crouton with traditional Caesar dressing",
            },
            {
              name: "Crunchy Detox Salad",
              description:
                "Delicious & healthy full of vibraint colours with ginger honey dressing",
            },
            {
              name: "Classic Italian Pasta Salad",
              description:
                "The perfect potluck/summer side dish with Italian cocktails dressing",
            },
            {
              name: "Greek Vegetables Salad",
              description:
                "Fresh mixed green vegetables with lemon vineger dressing.",
            },
            {
              name: "Warm Beans Chicken with Horseradish Cream",
              description:
                "Green beans in creamy horseradish with cherry tomatoes",
            },
            {
              name: "Classic Caessar Salad",
              description:
                "All time favorite crispy romaine lettuce with traditional Caesar dressing.",
            },
          ],
          starter: [
            {
              name: "Peri-Peri Chicken Tikka",
              description:
                "- Tender and juicy chicken cooked & marinated in peri-peri sauce",
            },
            {
              name: "BBQ Chicken Wings",
              description:
                "- Oregano, bell pepper, chilli flakes-slightly sweet and extra smoky flavour",
            },
            {
              name: "Jamican Chicken Strips",
              description:
                "- Season chicken with their lime-scented dipping sauce.",
            },
            {
              name: "Fish Fingers",
              description:
                "- Crispy from outside & soft from inside, corn flour, boneless fish in spice masala",
            },
            {
              name: "Carrebian Jerk Chicken",
              description:
                "- Delicious & super tender roasted chicken in Carrebian style.",
            },
            {
              name: "Citrus Chilli Prawns",
              description:
                "- Roasted Prawns with cherry tomato in basil flavour.",
            },
            {
              name: "Peri-Peri Paneer Tikka",
              description:
                "- Unique, tasty & spicy paneer marinated in peri-peri sauce.",
            },
            {
              name: "Baked Stuffed Mushroom with Cheddar Sauce",
              description:
                "- Puffy & perky packed with cheesy flavour in cheddar sauce.",
            },
            {
              name: "Loaded Mexican Nachos with Sour Cream",
              description: "- Nachos, tomato salsa, cheese sauce, sour cream",
            },
            {
              name: "Fresh Garden Vegetables Skewers with Kaffir Lime Sauce",
              description:
                "- Healthy fresh seasonal mixed vegetables with kaffir lime sauce",
            },
            {
              name: "Bbq Chicken Wings (Nonveg)",
              description:
                "Flour coated fried chicken wings tossed with colorful bell peppers parsley with BBQ sauce",
            },
            {
              name: "Oven Roasted Stuffed Mushroom (Veg)",
              description:
                "Delicious core mushroom stuffed with creamy spinach in cheddar cheese.",
            },
            {
              name: "Jerk Chicken Wings (Non Veg)",
              description:
                "flour coated fried chicken wings tossed with colourful bell peppers in Jerk sauce",
            },
            {
              name: "Double Decker Mushroom (Veg)",
              description: "Crumb fried cheesy stuffed mushroom",
            },
            {
              name: "Cajun Marinated Grilled Shrimp (Non Veg)",
              description: "Grilled shrimp in creamy Cajun sauce",
            },
            {
              name: "Hammush-Falafel With Pita Bread (Veg)",
              description:
                "Chickpeas patty falafel with rich creamy hummus, stuffed in pita bread",
            },
            {
              name: "Roasted Chicken Pita Pocket",
              description:
                "roasted shredded chicken stuffed in pita bread, hummus",
            },
            {
              name: "Cuban Cigar Roll.",
              description:
                "Cigar shaped rolls stuffed with mix of cheese, herbs served with five different dips",
            },
            {
              name: "Friendly Potato Basket",
              description:
                "Varieties of potato wedges, nuggets, fries & smiley",
            },
          ],
          main: {
            Veg: [
              {
                name: "Spaghetti In Pasto Sauce (Veg)",
                description:
                  "Basil flavour, creamy Spaghetti with assorted vegetables",
              },
              {
                name: "Panne Arabiatta (Veg)",
                description: "Chunky tomato sauce, assorted vegetables",
              },
              {
                name: "SPAGHETTI Aglio E OLIO (Veg)",
                description:
                  "Garlic, roasted chilli flakes, chopped parsley & parmesan tossed with spaghetti",
              },
              {
                name: "Truffle Mushroom Rissoto (Veg)",
                description:
                  "Creamy delicious Araborio rice cooked with mushroom, fresh herbs",
              },
              {
                name: "Grilled Vegetable with Garlic Cream Sauce",
                description:
                  "Beans, Mushroom (Seasonal vegetables) garlic cream sauce",
              },
              {
                name: "Green Peas Risotto",
                description: "Fresh green peas, risotto rice with white wine.",
              },
              {
                name: "Vegetables Filo Pastry",
                description: "Zucchini, Mash potato, Cheddar cheese.",
              },
              {
                name: "Gnocchi potato Broccoli & Slow Roasted Onion",
                description: "Potato, Broccoli, Butter Cream.",
              },
            ],
            NonVeg: [
              {
                name: "Grilled Zatar Fish (Non Veg)",
                description: "Assorted vegetable creamy zatar sauce",
              },
              {
                name: "Pasta in Alfredo Sauce (Non-Veg)",
                description: "Creamy béchamel with dice ham & green peas",
              },
              {
                name: "Spaghetti In Pasta Sauce (Non-Veg)",
                description:
                  "Basil flavour, creamy Spaghetti with assorted vegetables",
              },
              {
                name: "Panne Arabiatta (Non-Veg)",
                description: "Chunky tomato sauce, assorted vegetables",
              },
              {
                name: "SPAGHETTI Aglio E OLIO (Non-Veg)",
                description:
                  "Garlic, roasted chilli flakes, chopped parsley & parmesan tossed with spaghetti",
              },
              {
                name: "Grilled Pork Chop (Non Veg)",
                description:
                  "Sauté green beans, caramelized onion, parmesan sauce",
              },
              {
                name: "Pan Seared Salmon With Vegetable Spaghetti (Non Veg)",
                description:
                  "Julienne carrot, zucchini sauté creamy caper sauce serve with garlic fresh herbs tossed spaghetti.",
              },
              {
                name: "Stuffed Chicken Breast (Non Veg)",
                description:
                  "Chicken breast stuffed with cheese, parsley, herbs & pan seared",
              },
              {
                name: "Grilled Stuffed Chicken with Mushroom Sauce",
                description: "Spinach, Onions, Mushroom Sauce.",
              },
              {
                name: "Braised Lamb with Chinmichuri Potato Spinach & Grape wine Juice",
                description: "Spinach, Onions, Mushroom sauce.",
              },
              {
                name: "Grilled Fish Butter Caper Sauce",
                description:
                  "Soul fish, Butter, Caper sauce, Broccoli, Mushroom.",
              },
              {
                name: "Peri-Peri Chicken Breast with Peri-Peri Sauce",
                description: "Tomato, Peri-Peri sauce",
              },
              {
                name: "Grilled Chicken Breast with Fragment Rice & Mushroom",
                description: "Fragment rice, Mushroom, chicken breast",
              },
            ],
          },
          pasta: [
            {
              name: "Mac & Cheese",
              description: "Macaroni pasta, cheese cream.",
            },
            {
              name: "Spaghetti Aglio E Olio",
              description: "Noodles, Parsley, Parmesan cheese.",
            },
            {
              name: "Penne Abrabiata",
              description: "Red sauce, Mushroom, Broccoli, Zucchini.",
            },
          ],
        }
      },
      {
        type: "chinese",
        title: "Chinese",
        cover_image: chineseCover,
        items: {
          soup: [
            {
              name: "Crispy Ramen Soup (Veg/ Non.Veg)",
              description: "Crispy Ramen Noodels with Japanese flavour soup.",
            },
            {
              name: "Clear Soup (Veg/Non-Veg)",
              description:
                "Flavour of lemon & corriander with chooped broccoli, baby corn, carrot & cabbage.",
            },
            {
              name: "Lemon Coriander (Veg/Non-Veg)",
              description:
                "Flavour of lemon & coriander with chooped broccoli, baby corn, carrot & cabbage.",
            },
            {
              name: "Hot & Sour (Veg/Non-Veg)",
              description:
                "Spicy coriander flavour with julian cutting vegetable, black Mushroom, carrot.",
            },
            {
              name: "Manchow (Veg./Non-Veg)",
              description:
                "Garlic flavour with chopped carrot, cabbage, button mushroom, coriander.",
            },
            {
              name: "Tom Yum (Veg/Non-Veg)",
              description:
                "Thai herbs flavour with dice carrot, coriander, onion & Mushroom.",
            },
          ],
          starter: [
            { name: "Honey Chilli Chilli Potato", description: "" },
            {
              name: "Sechzwan Style Chilli Paneer",
              description: "Crush sechzwan with colourful bell Peppers.",
            },
            { name: "Vegs Salt & Pepper", description: "" },
            {
              name: "Chinese Bao ( Veg/Chicken/Prawns)",
              description:
                "Traditional Chinese steam bun stuffed with various type of filling.",
            },
            {
              name: "Chilli Garlic Tofu",
              description: "Spicy fried tofu with colourful bell peppers.",
            },
            {
              name: "Chilli Mushroom",
              description:
                "A classic indo-chinese snack, fried mushroom coated with soya sauce.",
            },
          ],
          main: [
            {
              name: "Classy Cafe Oodle Noodle",
              description:
                "Soft, Tongue smoothing noodles in chilli oyster sauce.",
            },
            {
              name: "Pad Thai Noodle",
              description: "Mix vegetables in hoisen sauce.",
            },
            { name: "Thai Style Chilli Prawns", description: "" },
            {
              name: "Szechwan Chicken gravy",
              description:
                "Delicious & flavourful dish in spicy sour, hot & Tongue-tickling sechzwan sauce.",
            },
            {
              name: "Chicken in Black Bean",
              description:
                "Rich black bean sauce, spring onions, bell pepper brings out the best flavour of the chicken.",
            },
            {
              name: "Malaysian Clay Port",
              description: "Steamed chicken in Malaysian sauce",
            },
            {
              name: "Minced Chicken Chilli Basil",
              description:
                "Authentic recipe with ground chicken in Thai basil & chilli.",
            },
            {
              name: "Kung Pao Chicken",
              description:
                "Chicken with diced onion & spring onions flavour slightly sweet, spicy & sour.",
            },
            {
              name: "Chicken in Hot Basil",
              description: "Roasted chicken in hot basil.",
            },
            {
              name: "Fish in Hot Garlic Sauce",
              description:
                "Delicious Chinese recipe served with fish in oriented sauce topped with assorted sauted vegetables",
            },
          ],
          noodle: [
            { name: "Pork Noodles", description: "" },
            {
              name: "Chilli Garlic Noodles (Veg./Chicken/Prawns)",
              description: "",
            },
            { name: "Hakka Noodles (Veg./Chicken/Prawns)", description: "" },
          ],
          dimsum: [
            { name: "Dimsum Momos (Veg)", description: "" },
            { name: "Veg Kothe Dumpling", description: "" },
            { name: "Truffle Mushroom Dumpling", description: "" },
            { name: "Vegs Kothe Dumpling", description: "" },
          ],
        }
      },
      {
        type: "tandoori",
        title: "Tandoori",
        cover_image: tandoori,
        items: {
          veg: [
            { name: "Papad Masala" },
            { name: "Tandoori Mushroom" },
            { name: "Veg. Seekh Kabab" },
            { name: "Hara Bara Kabab" },
            { name: "Panner Malai Tikka" },
            { name: "Paneer Achary Tikka" },
            { name: "Malai Soya Chaap" },
            { name: "Tandoori Soya Chaap" },
            { name: "Panner Tikka" },
          ],
          nonVeg: [
            { name: "Fish Aachari Tikka" },
            { name: "Fish Tikka" },
            { name: "Tandoori Prawns" },
            { name: "Drum Stick Chicken" },
            { name: "Haryali Chicken Tikka" },
            { name: "Chicken Aachari Tikka" },
            { name: "Chicken Gillafi Seekh" },
            { name: "Chicken Malai Tikka" },
            { name: "Chicken Seekh Kabab" },
            { name: "Mutton Seekh Kabab" },
            { name: "Afghani Chicken (4/8 Pieces)" },
            { name: "Chicken Tikka" },
            { name: "Tandoori Chicken (Half/Full)" },
          ],
        }
      },
      {
        type: "indian",
        title: "Indian",
        cover_image: indian,
        items: {
          "Non-Veg": [
            { name: "Mutton Sagh Wala" },
            { name: "Murg Sagh Wala" },
            { name: "Fish Curry" },
            { name: "Rahra Mutton" },
            { name: "Rahra Chicken" },
            { name: "Bhuna Chicken" },
            { name: "Mutton Rogan Josh" },
            { name: "Chicken Tikka Masala" },
            { name: "Chicken Curry" },
            { name: "Butter Chicken Boneless" },
            { name: "Butter Chicken" },
            { name: "Kadhai Chicken" },
          ],
          Veg: [
            { name: "Khumb Pyaaz Bhujia" },
            { name: "Palak Paneer" },
            { name: "Matar Mushroom Masala" },
            { name: "Palak Corn" },
            { name: "Paneer Tikka Masala" },
            { name: "Soya Chaap Masala" },
            { name: "Paneer Lababdar" },
            { name: "Paneer Hungama" },
            { name: "Khadhai Paneer" },
            { name: "Paneer Makhani" },
            { name: "Mix Vegetables" },
            { name: "Yellow Dal Tadka" },
            { name: "Dal Makhani" },
            { name: "Dal Panchrangi" },
          ],
          "Indian Rice": [
            { name: "Mutton Biryani" },
            { name: "Chicken Biryani" },
            { name: "Prawns Fried Rice" },
            { name: "Egg Fried Rice" },
            { name: "Chicken Fried Rice" },
            { name: "Veg. Fried Rice" },
            { name: "Sticky Rice" },
            { name: "Steam Rice" },
          ],
          "Indian Breads": [
            { name: "Laccha Parantha" },
            { name: "Garlic Naan" },
            { name: "Butter Naan" },
            { name: "Missi Roti" },
            { name: "Tandoori Roti" },
          ],
        }
      },
      {
        type: "north-east-cuisine",
        title: "North-east cuisine",
        cover_image: northeast,
        items: {
          Starter: [
            { name: "Fish With Dry Bamboo Shoot" },
            { name: "Dry Fried Fish (Dep Fried Fish)" },
            { name: "Steam Fish" },
            { name: "Chicken Gizzards" },
            { name: "Chicken Wings with Dry Bamboo Shoot" },
            { name: "Chicken with Bamboo Shoot" },
            { name: "Smoked Pork with Bamboo Shoot" },
            { name: "Fresh Pork with Dry Bamboo Shoot" },
            { name: "Pork Ribs" },
          ],
          Mains: [
            { name: "Chicken with Bamboo Shoot" },
            { name: "Fish with Bamboo Shoot" },
            { name: "Smoke Pork with Organic Yum/ Pumkin" },
            { name: "Smoke Pork with (Axone/Bamboo Shoot)" },
            { name: "Fresh Pork with" },
            { name: "Mixed Veggies with Organic Naga Green Chili" },
          ],
          "Side Dish": [
            { name: "Special Green Teapot (Peach/Ginger/Gasmine)" },
            { name: "Steam Veggies with Naga Herbs" },
            { name: "Roasted Green Beans" },
            { name: "Eronba (Organic Naga King Chilli)" },
          ],
        }
      },
      {
        type: "bar-menu",
        title: "Bar Menu",
        cover_image: barmenu,
        items: {
          "Indian Beer (330ml)": [
            { name: "Corona Beer" },
            { name: "Heineken" },
            { name: "Simba" },
            { name: "Bira blonde" },
            { name: "Bira white" },
            { name: "Kingfisher ultra max" },
            { name: "Kingfisher ultra" },
            { name: "Kingfisher primer" },
          ],
          "Imported Beer (330ml)": [
            { name: "Hopper" },
            { name: "Hoegaarden Beer" },
            { name: "Erdinger" },
            { name: "Hipper blonde" },
            { name: "Hopper white" },
          ],
          "Liqueurs (30ml)": [
            { name: "Sambuca" },
            { name: "Baileys" },
            { name: "Jagermeister" },
          ],
          "Sparkling Wine (Bottle)": [
            { name: "Sula rose" },
            { name: "Sula brut" },
            { name: "Chandon brut" },
          ],
          "White Wine (Glass)": [
            { name: "Fratelli (sauvignon Blanc)" },
            { name: "Fratelli (chainBlanc)" },
            { name: "Sula (sauvignon Blanc)" },
            { name: "Jacob's creek (chardonnay)" },
          ],
          "Imported Blended Scotch (30ml)": [
            { name: "Johnnie Walker Gold Label" },
            { name: "Cardha 12 Yrs" },
            { name: "Macallan 12 Yrs" },
            { name: "Talisker" },
            { name: "Laphroaiy 10 Yrs" },
            { name: "Balxenie 12yrs" },
            { name: "Glenkinchie" },
            { name: "Glenfiddich 12yrs" },
            { name: "Glenmorangi 10 Years" },
            { name: "Ballantine finest" },
            { name: "Jw red label" },
            { name: "Jw black label" },
            { name: "Chivas regal (12-years old)" },
          ],
          "Bourbon/Tennessee/Irish (30ml)": [
            { name: "Jameson" },
            { name: "Jack Daniel's (old no 7)" },
          ],
          "Single Malt (30ml)": [{ name: "The Glenlivet (12-years old)" }],
          "Red Wine (Glass)": [
            { name: "Fratelli (Shiraz)" },
            { name: "Jacob's creek (merlot)" },
          ],
          "Vodka (30ml)": [
            { name: "Gray Goose" },
            { name: "Belvedere" },
            { name: "Eristoff" },
            { name: "Blue eyes" },
            { name: "Smirnoff" },
            { name: "Grey goose" },
            { name: "Absolut" },
            { name: "Blue moon" },
          ],
          "Rum (30ml)": [
            { name: "Old monk" },
            { name: "Bacardi black" },
            { name: "Bacardi white" },
            { name: "Bacardi Breezer" },
            { name: "BREEZER CRANBERRY/ORANGE/JAMACIAN/BLUBERRY/LIME" },
          ],
          "Tequila (30ml)": [{ name: "Viva mojo" }],
          Signatures: [
            { name: "Love for lady" },
            { name: "Fresh garden" },
            { name: "Passion pit" },
            { name: "Pop!" },
            { name: "What a match (a)" },
            { name: "Ocean view" },
            { name: "Man-li mug-rita" },
            { name: "Sunrise" },
          ],
          "Classic Cocktails": [
            { name: "Margarita" },
            { name: "Daiquiri" },
            { name: "Sex-on-the-beach" },
            { name: "Mojito" },
            { name: "L.I.I.T" },
            { name: "Cosmopolitan" },
            { name: "Pink lady" },
            { name: "Bloody Mary" },
            { name: "Whiskey sour" },
            { name: "Old fashioned" },
          ],
          Shots: [
            { name: "Jagger bomb" },
            { name: "B52" },
            { name: "Beer bomb" },
            { name: "Strawberry" },
            { name: "Blue kamikaze" },
            { name: "Green hornet" },
            { name: "Kamikaze" },
          ],
          Mocktails: [
            { name: "Italian smooch" },
            { name: "Pomi twist" },
            { name: "Kala khata" },
            { name: "Blue heaven" },
            { name: "Watermelon collar" },
            { name: "Classy Virgin sangria red/white" },
            { name: "Classy Virgin margarita" },
            { name: "Virgin hot toddy" },
            { name: "Virgin Pina colada" },
            { name: "Virgin Mary" },
            { name: "Virgin mojito" },
            { name: "Passion peach" },
            { name: "Classy Green mint cooler" },
            { name: "Classy Immunity booster" },
          ],
        }
      }
    ]
  }
];

export default Data;
